import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VMask from "@ssibrahimbas/v-mask";

import { registerServiceWorker } from "@/push/registerSW"
import { initSentry } from '@/config/sentry'

import '@/assets/style/commom.sass'

const app = createApp(App)
initSentry(app, router)
app.use(store)
app.use(router)
app.use(VMask)

app.mount('#app')

registerServiceWorker()
